import React from 'react';

function ThemedSearchInput({ searchTerm, onSearchChange, placeholder = "Search..." }) {
    return (
        <div className="search">
            <div className="search-wrapper">
                <div className="icon-wrapper">
                    <i className="fa-solid fa-magnifying-glass"></i>
                </div>
                <input
                    className="search-input"
                    type="text"
                    placeholder={placeholder}
                    value={searchTerm}
                    onChange={(e) => onSearchChange(e.target.value)}
                />
            </div>
        </div>
    );
}
export default ThemedSearchInput;